export default "__VITE_ASSET__DhzNqQc6__"